import UMCModal from "../../common/UMCModal"
import ComboBoxField from "../../common/ComboBoxField"
import ToggleButton from "../../common/ToggleButton"
import { Tooltip } from "antd"
import ProgKeysActionbar from "./ProgKeysActionbar"
import info_icon from "../../../assets/images/icon_info.svg"
import RadioButton from "../../common/RadioButton"
import { useEffect, useState } from "react"
import ProgKeysTab from "./ProgKeysTab"
import { InfoCircleFilled } from "@ant-design/icons"
import { getImage, getTranslated } from "../../../utils/CommonUtils"
import { useDispatch, useSelector } from "react-redux"
import { getProgKeysData, getProgKeysFunctionSchema, updateProgKeys } from "../../../store/actions/ProgKeysAction"
import HardKeysTab from "./HardKeysTab"
import { ADD, FUNC_DETAIL, FUNCTION, NOE_IPDSP, PK_TOGGLE_OPTIONS, SIP, UPDATE } from "../../../utils/Constants"
import { checkIfAnyModified, findInObjectById, updateObjectById } from "../../../utils/SchemaParseUtils"
import { UMC_DEVICES } from "../../../utils/DeviceConstants"
import { setCurrModalMergedData } from "../../../store/reducers/CommonReducer"
import ProgKeysFooter from "./ProgKeysFooter"
import parse from 'html-react-parser'
import { setPkActionMode, setPKParentActionMode, setProgKeysCurrData, setProgKeysData } from "../../../store/reducers/ProgKeysReducer"
import _ from "lodash"
import confirmModal from "../../common/confirmModal"
import { getAddonOptions, getDeviceGenericType } from "../../../utils/ProgKeysUtils"
import { sendGTMEvent } from "../../../utils/GTMUtils"

const profileList = [{ label: "dummy prof", value: "prof1" }]

const ProgrammableKeysModal = (props) => {

    const [open, setOpen] = useState(props.open)
    const [isProgKeysTab, setIsProgKeysTab] = useState(true)
    const [selectedAddOn, setSelectedAddOn] = useState()
    const [existingAddon, setExistingAddon] = useState()
    const [umcSetType, setUmcsettype] = useState()
    const [progKeyCategory, setProgKeyCategory] = useState()
    // const [pkActionMode, setActionMode] = useState(ADD)
    const [addonOption, setAddonOption] = useState([])
    const [loading, setLoading] = useState(false)

    // const progKeysSchema = useSelector(state => state.progkeys.progKeysSchema)
    const progKeysData = useSelector(state => state.progkeys.progKeysData)
    const progKeysCurrData = useSelector(state => state.progkeys.progKeysCurrData)
    const progKeysFuncSchema = useSelector(state => state.progkeys.progKeysFuncSchema)
    const currentMergedData = useSelector((state) => state.common.currentMergedData)
    const dict = useSelector(state => state.common.dict)
    const pkActionMode = useSelector(state => state.progkeys.pkActionMode)
    const pkParentActionMode = useSelector(state => state.progkeys.pkParentActionMode)

    const dispatch = useDispatch()


    useEffect(() => {
        setLoading(true)
        // !Object.keys(progKeysSchema).length && dispatch(getProgKeysSchema())

        const umcSetType = findInObjectById(currentMergedData, "umcsettype")
        setUmcsettype(umcSetType?.value)

        return (() => {
            dispatch(setCurrModalMergedData(null))
            dispatch(setPkActionMode(ADD))
            dispatch(setPKParentActionMode(ADD))
            dispatch(setProgKeysData([]))
            dispatch(setProgKeysCurrData([]))
        })
    }, [])


    useEffect(() => {
        const deviceInfo = UMC_DEVICES.find(device => device.umcSetType === umcSetType)

        if (deviceInfo) {
            const type = getDeviceGenericType(deviceInfo.progkeycategory)
            const addonOption = getAddonOptions(deviceInfo.progkeycategory, dict) // Get respective radio btn options
            // Get Progkeys data
            props.dn && dispatch(getProgKeysData(props.dn, type, (response) => {  //Todo - optimize
                dispatch(setProgKeysData(response?.domain))

                const addonObj = findInObjectById(response?.domain, "addonmodule")
                setExistingAddon(addonObj?.value ?? addonOption[0].value)
                handleAddonSelection(addonObj?.value ?? addonOption[0].value, response?.domain, addonObj?.value, (updatedData) => {
                    dispatch(setProgKeysCurrData(updatedData))
                })
                setLoading(false)
            }))

            dispatch(getProgKeysFunctionSchema(type)) // Get Programmable keys function schema

            setAddonOption(addonOption)
            setProgKeyCategory(deviceInfo.progkeycategory)
        }
    }, [umcSetType, props.dn])


    /* isSaved - Addon not selected & saved in OXE prev */
    const handleAddonSelection = async (value, custData = null, savedAddon = "", callback) => {
        setSelectedAddOn(value)

        // Update selected addon value to the progKeysCurrData payload
        const updatedData = await updateObjectById(custData || progKeysCurrData, "addonmodule", (data) => {
            let tempData = _.cloneDeep(data)
            if (tempData) {
                tempData.value = value
                const oldAddon = (savedAddon || existingAddon)
                // If addon selected is not 'without addon' or 'without addon' is selected but addon was existing prevly
                if ((value?.slice(-1) !== "0") || ((value?.slice(-1) === "0") && !custData)) {
                    if ((oldAddon !== value)) {
                        tempData.action = UPDATE
                        tempData.isModified = true
                    } else if (tempData.action) { // If addon changed back to existing value, remove action & isModified
                        delete tempData.action
                        delete tempData.isModified
                    }
                }
            }

            return tempData
        })
        dispatch(setProgKeysCurrData(updatedData))
        callback && callback(updatedData)
    }

    const handleSaveAllKeys = (data = null) => {
        setLoading(true)
        dispatch(updateProgKeys(props.dn, data || progKeysCurrData, dict, setLoading, (response) => {  //Todo - optimize
            dispatch(setProgKeysData(response?.domain))
            const addonObj = findInObjectById(response?.domain, "addonmodule")
            if(addonObj?.value && selectedAddOn === addonObj.value) {
                setExistingAddon(selectedAddOn)
                dispatch(setProgKeysCurrData(response?.domain))
            } else {
                setExistingAddon(addonObj?.value ?? addonOption[0].value)
                handleAddonSelection(addonObj?.value ?? addonOption[0].value, response?.domain, addonObj?.value, (updatedData) => {
                    dispatch(setProgKeysCurrData(updatedData))
                })
            }
            setLoading(false)
        }))
        // Send GTM event for programmable keys save action
        sendGTMEvent({
            event: "umc_easy_user_config",
            action: "Save in ProgKeys popup"
        })
    }

    const getSaveAllDisableBtnState = () => {

        return (progKeysCurrData?.length && (progKeysCurrData[0].attribute?.some(key => key.action) || // any key modified
            (existingAddon && (selectedAddOn !== existingAddon))) // addon changed. Skip if existingAddon is not set
            ? false : true)
    }

    const hasUnsavedChanges = () => {

        return checkIfAnyModified(progKeysCurrData) || progKeysCurrData[0].attribute?.some(key => key.action) || selectedAddOn !== existingAddon
    }

    const handleClose = () => {
        if (hasUnsavedChanges()) {
            confirmModal({
                title: "MSG_LEAVE_PAGE",
                content: "MSG_LOSE_CONFIG",
                onOk: () => {
                    setOpen(false)
                    props.notifyClose() //Notify it's parent about the modal's close
                }
            })
        } else {
            setOpen(false)
            props.notifyClose() //Notify it's parent about the modal's close
        }
    }

    const handleCancel = () => {
        const progKeysDataCloned = _.cloneDeep(progKeysData)

        if (hasUnsavedChanges()) {
            confirmModal({
                title: "MSG_LEAVE_PAGE",
                content: "MSG_LOSE_CONFIG",
                onOk: () => {
                    setSelectedAddOn(existingAddon)
                    dispatch(setPKParentActionMode(ADD))
                    dispatch(setProgKeysCurrData(progKeysDataCloned))
                }
            })
        } else {
            setSelectedAddOn(existingAddon)
            dispatch(setPKParentActionMode(ADD))
            dispatch(setProgKeysCurrData(progKeysDataCloned))
        }
    }

    const getDeviceImage = () => {
        const selectedAddonNo = selectedAddOn?.slice(-1) // slice to get last char i.e. addon number [ 0 | 1 | 2 | 3 ]
        if (progKeyCategory.includes(SIP) || selectedAddonNo == 0 || progKeyCategory === NOE_IPDSP) // To avoid datatype difference
            return getImage(`device_${umcSetType?.replace(/\s+/g, '')}.png`)
        else {
            // [ALE-20h, ALE-20h tdm, ALE-20h ip], [ALE-30h, ALE-30h tdm, ALE-30h ip] shares same device images
            const setType = umcSetType.includes("ALE-20h") ? "ALE-20h" : umcSetType.includes("ALE-30h") ? "ALE-30h" : umcSetType?.replace(/\s+/g, '')

            return getImage(`device_${setType}-${selectedAddonNo}.png`)
        }
    }

    const getLeftSectionView = () => {
        const deviceImg = progKeyCategory && getDeviceImage()

        return <div className="left-section">
            <div className="pk-left-title">{getTranslated(dict, "LABEL_CONFIGURATION")}
                {progKeyCategory?.includes(SIP) ? <Tooltip title={<>
                    {parse(getTranslated(dict, "LABEL_SIP_ALE_120_INFO"))}
                    <img src={getImage("device_ALE-120.png")} alt="" className="pk-tt-img" />
                </>}>
                    <InfoCircleFilled style={{ fontSize: "0.8em" }} className="pk-title-info" />
                </Tooltip> : <></>}
            </div>
            <img src={deviceImg} alt={deviceImg} className="pk-device-img" />
            <div>
                <div className="device-name">{umcSetType} </div>
                {progKeyCategory?.includes("NOE") ? <>
                    <div className="pk-noe-warning-div"><img src={info_icon} alt="Warning" /> {getTranslated(dict, "LABEL_WARNING")}
                        <div>{getTranslated(dict, progKeyCategory === NOE_IPDSP ? "MSG_IPDSP_ADDON" : "MSG_ADDON")}</div></div>
                    <RadioButton
                        parentClassName="pk-addon-radio-btn"
                        options={addonOption}
                        value={selectedAddOn}
                        disabled={pkActionMode !== ADD}
                        handleChange={(value) => handleAddonSelection(value)}
                    />
                </> : <></>}
            </div>
            {/* <div className="pk-profile"> // Hide Profile selection atm for 1.1
                <div>{getTranslated(dict, "MSG_CHOOSE_PROF")}:</div>
                <ComboBoxField enum={profileList} />
                <button>LABEL_CREATE_PROFILE</button> // todo
            </div> */}
        </div>
    }

    const getContent = () => {

        return <div id="prog-keys">
            <div className="pk-section">
                {
                    getLeftSectionView()
                }
                <div className="right-section">
                    <div className="pk-right-title">
                        <ToggleButton
                            options={PK_TOGGLE_OPTIONS}
                            handleChange={(value) => setIsProgKeysTab(value)}
                        />
                        <ProgKeysActionbar />
                    </div>
                    {isProgKeysTab ? <ProgKeysTab
                        progKeysFuncSchema={progKeysFuncSchema}
                        progKeyCategory={progKeyCategory}
                        selectedAddOn={selectedAddOn}
                        dn={props.dn}
                        handleSaveAllKeys={handleSaveAllKeys}
                        umcSetType={umcSetType}
                    /> : <HardKeysTab />}
                </div>
            </div>
        </div>
    }

    const saveDisabled = getSaveAllDisableBtnState()

    return <UMCModal
        className="pk-modal"
        open={open}
        content={getContent()}
        footer={(pkActionMode === FUNCTION || pkActionMode === FUNC_DETAIL) ? null : <ProgKeysFooter
            handleSave={handleSaveAllKeys}
            okDisabled={saveDisabled}
            handleCancel={(saveDisabled && pkParentActionMode === ADD) ? handleClose : handleCancel}
            cancelText={(saveDisabled && pkParentActionMode === ADD) ? "LABEL_CLOSE" : "LABEL_CANCEL"}
        />}
        onCancel={() => handleClose()}
        closable={true}
        centered={true}
        loading={loading}
        // width={(width <= 1498) ? 614 : 1000}
        width={"50%"}
        style={{
            height: "auto",
            minWidth: "515px"
        }}
        destroyOnClose={true}
    />
}

export default ProgrammableKeysModal